// Popover - toggles on click, opens on hover (desktop), closes on outside click + Esc
import { qsa, on, delegate } from '../lib/dom.js';

const HOVER_OPEN_MS = 80;
const HOVER_CLOSE_MS = 180;

function setOpen(pop, trigger, open) {
  pop.classList.toggle('is-open', open);
  if (trigger) trigger.setAttribute('aria-expanded', String(open));
}

function closeAll(except) {
  qsa('.ap-popover.is-open').forEach((p) => {
    if (p === except) return;
    setOpen(p, p.querySelector('.ap-popover__trigger'), false);
  });
}

export function initPopovers() {
  const supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  qsa('[data-component="popover"]').forEach((pop) => {
    const trigger = pop.querySelector('.ap-popover__trigger');
    if (!trigger) return;

    let openTimer = null;
    let closeTimer = null;
    const clearTimers = () => {
      if (openTimer) { clearTimeout(openTimer); openTimer = null; }
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    };

    on(trigger, 'click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const isOpen = pop.classList.contains('is-open');
      closeAll(pop);
      setOpen(pop, trigger, !isOpen);
    });

    if (supportsHover) {
      on(pop, 'mouseenter', () => {
        clearTimers();
        openTimer = setTimeout(() => {
          closeAll(pop);
          setOpen(pop, trigger, true);
        }, HOVER_OPEN_MS);
      });
      on(pop, 'mouseleave', () => {
        clearTimers();
        closeTimer = setTimeout(() => setOpen(pop, trigger, false), HOVER_CLOSE_MS);
      });
    }

    // Close popover when an item link is clicked (so nav doesn't appear stuck)
    delegate(pop, 'click', '.ap-popover__item', () => {
      setOpen(pop, trigger, false);
    });
  });

  // Click outside closes any open popover
  on(document, 'click', (e) => {
    if (!e.target.closest('[data-component="popover"]')) closeAll();
  });

  // Escape closes
  on(document, 'keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });
}
